import React from 'react'

function TechCall() {
    return (
        <div className='tech__call'>
            <span className='box1__pick-number'>03</span>
            <span className='box1__pick-title'>Space launch 101</span>
        </div>
    )
}

export default TechCall